import { createFileRoute } from "@tanstack/react-router";
import { WaitlistPage } from "../components/landing/WaitlistPage";
import { useSEO } from "../hooks/useSEO";
import { SEO_CONFIG } from "../seo/seoConfig";

export const Route = createFileRoute("/waitlist")({
  component: WaitlistRoute,
});

function WaitlistRoute() {
  // Title/description/canonical/OG with cleanup (Story 30.2 useSEO).
  useSEO(SEO_CONFIG["/waitlist"]!);
  return <WaitlistPage />;
}
